import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCall from "../../api/apiCall";

export const getAffiliationById = createAsyncThunk(
  "affiliation/getAffiliationById",
  async (affiliationId, { rejectWithValue }) => {
    try {
      const response = await apiCall({
        url: `aff/affiliations/${affiliationId}/`,
        method: "GET",
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error ||
          error.response?.data?.message ||
          "Unable to load affiliation"
      );
    }
  }
);

const initialState = {
  affiliation: null,
  products: [],
  loading: false,
  error: null,
};

const affSlice = createSlice({
  name: "affiliation",
  initialState,

  reducers: {
    clearAffiliation: (state) => {
      state.affiliation = null;
      state.products = [];
      state.loading = false;
      state.error = null;
    },

    clearAffiliationError: (state) => {
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAffiliationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getAffiliationById.fulfilled, (state, action) => {
        state.loading = false;
        state.affiliation = action.payload;
        state.products = action.payload?.products || [];
      })

      .addCase(getAffiliationById.rejected, (state, action) => {
        state.loading = false;
        state.affiliation = null;
        state.products = [];
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { clearAffiliation, clearAffiliationError } = affSlice.actions;

export default affSlice.reducer;